
import { FLUTTER_IFRAME_WRAPPER_MAP } from './../../flutter/flutter.consts.js';
import { capitalizeWord, addLoadingSpinner, removeLoadingSpinner, handleProceedToPay, getDayAfterDate, resizeFrame, sendToGa4 } from './../../flutter/flutter.utils.js';
import('../../scripts/dbs/dbs.utilities.querystring')
// Flutter-Accommodation.js
// TODO: Handle state changes and URL history
export default class FlutterAccommodationSingleListing {
  constructor() {
    if (process.env.NODE_ENV === 'development') {
      console.log('flutter.accommodation-single: initializing');
    }
    this.moment = null;
    this.loadDependencies().then(() => {
      this.initializeProperties();
      this.initializeAccommodationEmbed();

      if (this.debugMode) {
        console.log('flutter.accommodation-single: initialized');
      }
    });
  }

  async loadDependencies() {
    const moment = await import('moment')
    this.moment = moment.default;
    await Promise.all([
      import(/* webpackMode: "eager" */ './flutter-accommodation.scss'),
      import('../../scripts/dbs/dbs.utilities.querystring'),
      import('../park-summary-tabs/park-summary-tabs'),
      import('../tab-current-deals/tab-current-deals'),
    ]);

  }

  initializeProperties() {
    const self = this;
    self.queryString = new dbs.utilities.querystring()
    self.$body = $('body')
    self.$wrapper = $(FLUTTER_IFRAME_WRAPPER_MAP['accommodation_single_listing'])
    self.embedBaseUrl = self.$wrapper.attr('data-embed-base-url')
    self.iframe = self.$wrapper.children('iframe')
    self.$backToParkLink = $(".backToParkLink")

    this.localDebugEnabled = true;
    this.debugMode == this.localDebugEnabled && process.env.NODE_ENV === 'development';
  }
  initializeAccommodationEmbed() {
    const self = this;
    if (this.$wrapper.length == 0) {
      if (self.debugMode) {
        console.warn('flutter.accommodation-single: No wrapper found for accommodation single listing widget')
      }
      return;

    }
    // Construct iframe link and load things in
    const bookingContext = self.getBookingContext()

    let iframeSrc = self.embedBaseUrl + this.createEmbedParams(bookingContext)

    // Check if we need to update the query string with defaults or not
    this.initQueryString();
    this.createIframe(iframeSrc);
    if ($('body').hasClass('no-scroll')) {
      $("body").removeClass('no-scroll');
    }
  }

  createEmbedParams(params) {
    var embedUrl = `/accommodation_info#?a=b&amp;msg_receiver=${params.siteUrl}&amp;accommodationCode=${params.accommodationCode}&amp;parkCode=${params.parkCode}&amp;checkIn=${params.checkIn}&amp;checkOut=${params.checkOut}&amp;adults=${params.adults}&amp;children=${params.children}&amp;infants=${params.infants}&amp;caller=${params.caller}&amp;gtmTag=${params.gtmTag}&amp;index=${params.index}`;
    if (params.dealCode != '') {
      embedUrl += `&amp;appliedDealId=${params.dealCode}`
    }
    return embedUrl;
  }


  getBookingContext() {
    let isDhp = $('html').hasClass('dhp-theme');
    const self = this;
    const siteUrl = self.$wrapper.attr('data-message-receiver');
    const accommodationCode = self.$wrapper.attr('data-accommodationCode');
    const propertyCode = self.$wrapper.attr('data-propertyCode');
    const checkIn = self.queryString.getParameter('arrive') ?? self.moment().format('YYYY-MM-DD')
    const checkOut = self.queryString.getParameter('depart') ?? getDayAfterDate(self.moment().format('YYYY-MM-DD'), self.moment)
    const adults = self.queryString.getParameter('adults') ?? 2
    const kids = self.queryString.getParameter('kids') ?? 0
    const infants = self.queryString.getParameter('infants') ?? 0
    const dealCode = self.queryString.getParameter('dealCode') ?? ''
    const caller = isDhp ? 'dhpWeb' : 'gdayWeb';
    const gtmTag = isDhp ? 'GTM-WDLRNW' : 'GTM-KCW5WKF';
    const index = self.queryString.getParameter('index') ?? 0

    //NOTE: Only add utm tags if available
    //Base from ticket GOE-91
    const j = self.queryString.getParameter('j') ?? ''
    const sfmc_sub = self.queryString.getParameter('sfmc_sub') ?? ''
    const l = self.queryString.getParameter('l') ?? ''
    const u = self.queryString.getParameter('u') ?? ''
    const mid = self.queryString.getParameter('mid') ?? ''
    const jb = self.queryString.getParameter('jb') ?? ''
    const utm_source = self.queryString.getParameter('utm_source') ?? ''
    const utm_medium = self.queryString.getParameter('utm_medium') ?? ''
    const utm_campaign = self.queryString.getParameter('utm_campaign') ?? ''
    const utm_term = self.queryString.getParameter('utm_term') ?? ''
    const utm_id = self.queryString.getParameter('utm_id') ?? ''
    const sfmc_id = self.queryString.getParameter('sfmc_id') ?? ''


    return {
      siteUrl: siteUrl,
      accommodationCode: accommodationCode,
      parkCode: propertyCode,
      checkIn: checkIn,
      checkOut: checkOut,
      adults: adults,
      children: kids,
      infants: infants,
      dealCode: dealCode,
      caller: caller,
      gtmTag: gtmTag,
      index: index,
      j: j,
      sfmc_sub: sfmc_sub,
      l: l,
      u: u,
      mid: mid,
      jb: jb,
      utm_source: utm_source,
      utm_medium: utm_medium,
      utm_campaign: utm_campaign,
      utm_term: utm_term,
      utm_id: utm_id,
      sfmc_id: sfmc_id
    };    
  }

  initQueryString() {
    const self = this;
    const params = self.getBookingContext(); // Gets defaults
    const queryString = self.queryString;

    // Define parameter mapping (query string name -> params object name)
    const paramMapping = {
      'arrive': 'checkIn',
      'depart': 'checkOut',
      'propertyCode': 'parkCode',
      'kids': 'children'
    };

    // Create reverse mapping for easier lookup
    const reverseMapping = Object.entries(paramMapping).reduce((acc, [queryParam, paramName]) => {
      acc[paramName] = queryParam;
      return acc;
    }, {});

    // Merge query string values with defaults
    Object.keys(params).forEach(paramName => {
      const queryParamName = reverseMapping[paramName] || paramName;
      const queryValue = queryString.getParameter(queryParamName);

      if (queryValue !== null && queryValue !== undefined && queryValue !== '') {
        params[paramName] = queryValue;
      }
      // If no query value, keep the default from getBookingContext()
    });

    // Remove unwanted parameters
    delete params.siteUrl;
    delete params.openPreviewWindow;
    delete params.gtmTag;
    delete params.caller;

    // Update URL with final parameter values
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([paramName, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        const urlKey = reverseMapping[paramName] || paramName;
        searchParams.set(urlKey, value);
      }
    });

    window.history.replaceState({}, '', "?" + searchParams.toString());
  }

  createIframe(url) {
    const self = this;
    var iframe = `<iframe src="${url}" scrollable="no" frameborder="0" seamless class="flutter-iframe" ></iframe>`
    var iframes = self.$wrapper.find('iframe')
    if (iframes.length > 0) {
      // remove iframes
      iframes.remove();
    }
    addLoadingSpinner(this.$wrapper);
    self.$wrapper.append(iframe);
  }

  handleEvent(eventType, eventData) {
    const self = this;
    switch (eventType) {
      case 'ga4Event':
        sendToGa4(eventData);
        break;
      case 'proceedToPay':
        const index = self.queryString.getParameter('index') ?? 0
        handleProceedToPay(eventData,index);
        break;
      case 'onResize':
        removeLoadingSpinner(this.$wrapper);
        resizeFrame(this.$wrapper, eventData.width, eventData.height, 0, 45);
        break;
      case 'bookingContextChanged':
        self.handleBookingContextChange(eventData);
        break;
      default:
        if (self.debugMode) {
          console.warn('flutter.accommodation-single: Unhandled event', eventType, eventData);
        }
        break;
    }
  }
  // handleBookingContextChange - Handles the booking context change event
  // @param {object} eventData - The event data to process
  // @returns {void}
  handleBookingContextChange(eventData) {
    // Get current URL parameters
    const self = this;
    const currentParams = new URLSearchParams(window.location.search);
    const bookingContext = eventData.bookingContext;

    // Map event values to URL parameters
    const paramMapping = {
      'parkCode': 'propertyCode',
      'checkIn': 'arrive',
      'checkOut': 'depart',
      'adults': 'adults',
      'children': 'kids',
      'infants': 'infants'
    };

    // Update parameters if different
    let hasChanges = false;
    for (const [eventKey, urlKey] of Object.entries(paramMapping)) {
      if (bookingContext[eventKey] !== currentParams.get(urlKey)) {
        currentParams.set(urlKey, bookingContext[eventKey]);
        hasChanges = true;
      }
    }

    // Only update history if there were changes
    if (hasChanges) {
      // Preserve other parameters that weren't in the event
      const newURL = `${window.location.pathname}?${currentParams.toString()}`;
      window.history.pushState({}, '', newURL);
      // Update "Back to park URL"
      let currentBackToPark = self.$backToParkLink.attr('href');
      let backToParkUrl = currentBackToPark.split('?')[0] + '?' + currentParams.toString();

      self.$backToParkLink.each(function (k, elem) {
        $(elem).attr('href', backToParkUrl);
      });
    }
  }
}
